import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import {
  queryGetResponseTimeLeaderboard,
  queryGetAverageResponseTime,
  queryGetResponseTime
} from "Apollo";
import { GetAnalyticFilter } from "Store";
import { observer } from "mobx-react";
import {
  InlineWidgetWrapper,
  WidgetMember,
  WidgetMember2
} from "./components/Widget";
import Chart from "./components/Chart";
import InlineOrderedBox from "./components/InlineOrderedBox";
import ManagedTable from "./components/ManagedTable";
import { formatTimestampToUnitValue } from "./util";
import Moment from 'moment';
const gqlOptions = {
  options: {
    fetchPolicy: "network-only"
  }
};
const Box = compose(
  graphql(queryGetResponseTimeLeaderboard, {
    ...gqlOptions,
    name: "leaderboard"
  }),
  graphql(queryGetAverageResponseTime, { ...gqlOptions, name: "average" }),
  graphql(queryGetResponseTime, { ...gqlOptions, name: "basic" })
)(
  class ResponseRatePanel extends Component {
    getChart() {
      const {
        leaderboard: { loading, getResponseTimeLeaderboard }
      } = this.props;
      let series = [];
      if (!loading && getResponseTimeLeaderboard) {
        const blockSeries = getResponseTimeLeaderboard.data.reduce(
          (memo, dataPoint) => {
            let timestamp = dataPoint.name;
            dataPoint.details.forEach(agent => {
              let name = agent.name;
              let value = agent.value / 1000;
              if (!memo[name]) {
                memo[name] = [];
              }
              memo[name].push({
                name: timestamp,
                value: value
              });
            });
            return memo;
          },
          {}
        );
        for (let agentName in blockSeries) {
          series.push({
            name: agentName,
            data: blockSeries[agentName]
          });
        }
      }
      let opt = {
        chartType: "line",
        title: "Response Time",
        series
      };
      return <Chart {...opt} />;
    }

    getSummary() {
      const { leaderboard, average } = this.props;
      let highestBox = {
        title: "Slowest",
        mainContent: "",
        footer: {
          text: ""
        }
      };
      let lowestBox = {
        title: "Fastest",
        mainContent: "",
        footer: {
          text: ""
        }
      };
      let averageBox = {
        title: "Average",
        mainContent: "",
        footer: {
          text: ""
        }
      };
      if (!leaderboard.loading && leaderboard.getResponseTimeLeaderboard) {
        const normalizedAgentValue = leaderboard.getResponseTimeLeaderboard.data
          .reduce((memo, item) => {
            return memo.concat(item.details);
          }, [])
          .sort((a, b) => {
            if(a.value < b.value) {
              return -1
            } else return 1
          }).filter(item => item.value > 0)
        if (normalizedAgentValue.length >= 2) {
          const lowest = normalizedAgentValue[0];
          const highest = normalizedAgentValue[normalizedAgentValue.length - 1];
          highestBox.mainContent = formatTimestampToUnitValue(
            highest.value, true
          ).join(" ");
          highestBox.footer.text = ("by "+ highest.name);
          lowestBox.mainContent = formatTimestampToUnitValue(
            lowest.value, true
          ).join(
            " "
          );
          lowestBox.footer.text = ("by "+ lowest.name);
        } else if (normalizedAgentValue.length === 1) {
          const elem = normalizedAgentValue[0];
          highestBox.mainContent = formatTimestampToUnitValue(
            elem.value, true
          ).join(
            " "
          );
          highestBox.footer.text = ("by "+ elem.name);
          lowestBox.mainContent = formatTimestampToUnitValue(
            elem.value, true
          ).join(
            " "
          );
          lowestBox.footer.text = elem.name;
        }
      }
      if (!average.loading && average.getAverageResponseTime) {
        if (average.getAverageResponseTime.data[0]) {
          const elem = average.getAverageResponseTime.data[0];
          averageBox.mainContent = formatTimestampToUnitValue(elem.value, true).join(
            " "
          );
        }
      }
      const opt = {
        contentList: [lowestBox, highestBox, averageBox],
        size: "small"
      };
      return <InlineOrderedBox {...opt} />;
    }

    getTable() {
      const { basic: { loading, getResponseTime } } = this.props;
      let series = [
        {
          date: "",
          rate: "",
          responded: "",
          incoming: ""
        }
      ];
      if (!loading && getResponseTime) {
        if (getResponseTime.data.length > 0) {
          series = getResponseTime.data.map(item => {
            let realRate = "-"
            if(item.value > 0) {
              realRate = formatTimestampToUnitValue(item.value).join(" ")
            }
            return {
              date: Moment(item.name).format("YYYY-MM-DD"),
              rate: realRate
            };
          });
        }
      }
      const opt = {
        title: "Daily Response Time",
        contentList: series
      };
      return <ManagedTable {...opt} />;
    }

    render() {
      const table = this.getTable();
      const chart = this.getChart();
      const summary = this.getSummary();
      return (
        <InlineWidgetWrapper>
          <WidgetMember>{chart}</WidgetMember>
          <WidgetMember2>
            {summary}
            {table}
          </WidgetMember2>
        </InlineWidgetWrapper>
      );
    }
  }
);

export default observer(
  class BoxWithQuery extends Component {
    render() {
      return <Box {...GetAnalyticFilter()} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/ResponseTimePanel.js